(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monolith-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const media = matchMedia('(min-width: 900px) and (prefers-reduced-motion: no-preference)');
    const stage = root.querySelector('.at-project-reveal__stage');
    const copy = root.querySelector('.at-positioning__copy');
    const cards = [...root.querySelectorAll('.at-triptych__card')];
    let frame = 0, focused = false;
    const clamp = n => Math.max(0, Math.min(1, n));
    function draw() {
      frame = 0;
      const active = media.matches;
      root.classList.toggle('is-animated', active);
      if (!active) {
        copy.style.visibility = '';
        copy.inert = false;
        cards.forEach(card => card.inert = false);
        return;
      }
      const p = focused ? 1 : clamp((-root.getBoundingClientRect().top) / 550);
      const eased = p * p * (3 - 2 * p);
      const width = stage.clientWidth, height = stage.clientHeight;
      const zoom = Math.max(1, width / (height * 3168 / 4096));
      root.style.setProperty('--clip', ((width - (width - 32) / 3) / 2 * eased) + 'px');
      root.style.setProperty('--zoom', zoom + (1 - zoom) * eased);
      root.style.setProperty('--side', clamp(p * 2));
      root.style.setProperty('--rise', ((1 - eased) * 50) + 'px');
      root.style.setProperty('--copy', 1 - clamp(p * 3));
      root.style.setProperty('--labels', clamp((p - .55) / .3));
      copy.style.visibility = p > .34 ? 'hidden' : 'visible';
      copy.inert = p > .34;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(draw); }
    root.querySelector('.at-triptych').addEventListener('focusin', () => { focused = true; schedule(); });
    root.querySelector('.at-triptych').addEventListener('focusout', () => { focused = false; schedule(); });
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    media.addEventListener('change', schedule);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        media.removeEventListener('change', schedule);
        cancelAnimationFrame(frame);
      }
    });
    draw();
  }
  document.querySelectorAll('[data-project-reveal]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-project-reveal]').forEach(mount));
})();

  } catch(e) { console.error(e); }
})();
})();
